import { createAction, createPayloadAction } from '../../../core/helpers'

import { FETCH_ALLERGEN, SET_ALLERGEN_PAGE_TO_DIRTY } from '../action-types'

export const cleanupFetchAllergen = createAction(FETCH_ALLERGEN.CLEANUP)

export const setAllergenPageIsDirty = createPayloadAction(
  SET_ALLERGEN_PAGE_TO_DIRTY,
)
